import { LifeBuoy } from 'lucide-react';
import { useMemo, useState } from 'react';

import { buildSupportReport } from '@/features/support/composables/report';

import type { SupportReportRequest } from '@/shared/api/types';
import type { ComponentProps } from 'react';

import { SupportReportDialog } from '@/features/support/components/SupportReportDialog';
import { Button } from '@/shared/ui/button';

export const SupportReportButton = ({
  error,
  report,
  componentStack,
  size,
  variant = 'outline',
  className,
}: {
  error?: unknown;
  report?: SupportReportRequest;
  componentStack?: string | null;
  size?: ComponentProps<typeof Button>['size'];
  variant?: ComponentProps<typeof Button>['variant'];
  className?: string;
}) => {
  const [open, setOpen] = useState(false);
  const baseReport = useMemo(
    () => report ?? buildSupportReport(error, componentStack),
    [report, error, componentStack]
  );

  return (
    <>
      <Button variant={variant} size={size} onClick={() => setOpen(true)} className={className}>
        <LifeBuoy />
        Report
      </Button>
      <SupportReportDialog open={open} onOpenChange={setOpen} baseReport={baseReport} />
    </>
  );
};
